import { homeApi } from '@features/home/api/homeApi'
import { useScrollToBlock } from '@features/home/composables/useScrollToBlock'
import { HOME_FALLBACK_TITLE } from '@features/home/constants'
import { createSeoHead } from '@shared/nuxt/createSeoHead'

/**
 * Подготавливает заголовок и SEO-данные главной страницы.
 *
 * @returns заголовок страницы и объект для Nuxt `useHead`
 */
export const useHomePage = async () => {
  const route = useRoute()
  const { $host } = useNuxtApp()
  useScrollToBlock()

  const { data: pageSeo } = await homeApi.getSeo()

  const title = pageSeo.value?.title ?? HOME_FALLBACK_TITLE

  return {
    title,
    seo: createSeoHead(
      $host,
      {
        title,
        keywords: pageSeo.value?.keywords ?? '',
        description: pageSeo.value?.description ?? '',
      },
      route.fullPath,
      route.path,
    ),
  }
}
